import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router-dom';
import { Page, PromiseContainer } from '../../../components';
import { useStore } from '../../../store';
import usePromise from '../../../store/utils/usePromise';
import UserForm from './components/UserForm';

export default observer(function EditUserPage() {
  const { userId = '' } = useParams<{ userId: string }>();
  const { userStore } = useStore();

  const [userPromise] = usePromise(() => userStore.fetchUser(userId));

  return (
    <Page navigation={userPromise.value?.displayName || '…'} surface="empty">
      <PromiseContainer promise={userPromise}>
        {(user) => <UserForm user={user} />}
      </PromiseContainer>
    </Page>
  );
});
